import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useOnClickOutside } from "../../hooks/useOnClickOutside";
import { UserContext } from "../common/UserContext";

import {
  getNotificationMessage,
  viewedAllNotificationMessage,
} from "../../controllers/notification";
import { ConstructNotificationMessage } from "../../utils/getNotificationMessage";
import NoDataFound from "../common/NoDataFound";
import "./notifications.css";

export type NotificationsT = {
  _id: string;
  event_name: string;
  org_id: string;
  org_name: string;
  details: {
    [key: string]: string;
  };
  isCleared: boolean;
  isViewed: boolean;
  critical: boolean;
};

const NotificationBell = () => {
  const { authToken } = useContext(UserContext);
  const [notificationsList, setNotificationsList] = useState<NotificationsT[]>(
    []
  );
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const BellBoxRef = useRef<HTMLDivElement>(null);

  const [showPopup, setShowPopup] = useState(false);
  const [activeCategory, setActiveCategory] = useState<"all" | "critical">(
    "critical"
  );

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleClickOutside = () => {
    setShowPopup(false);
  };

  const viewedAll = () => {
    viewedAllNotificationMessage(authToken).then(() => {
      togglePopup();
      history.push("/notifications");
    });
  };

  useOnClickOutside(BellBoxRef, handleClickOutside);
  const handleCategoryChange = (category: "all" | "critical") => {
    setActiveCategory(category);
  };

  useEffect(() => {
    setLoading(true);
    const fetchNotifications = async () => {
      await getNotificationMessage(authToken)
        .then((res) => {
          const filteredData = res.data.filter(
            (notification: NotificationsT) => !notification.isCleared
          );
          setNotificationsList(filteredData);
          const viewedData = res.data.filter(
            (notification: NotificationsT) => !notification.isViewed
          );
          setCount(viewedData.length);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 30000);
    return () => clearInterval(intervalId);
  }, [authToken]);

  const filteredNotifications =
    activeCategory === "all"
      ? notificationsList
      : notificationsList.filter((notification) => notification.critical);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <svg
        onClick={togglePopup}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="white"
        className="bi bi-bell"
        viewBox="0 0 16 16"
      >
        <path d="M8 16a2 2 0 0 0 1.985-1.75H6.015A2 2 0 0 0 8 16zm.104-14.626a4.002 4.002 0 0 1 3.696 3.999v2.071c0 .1.03.199.082.283l.563.896c.141.224.227.484.242.756h-9.352c.015-.272.1-.532.242-.756l.563-.896c.053-.084.082-.183.082-.283V5.373a4.002 4.002 0 0 1 3.696-3.999A.735.735 0 0 1 8 1a.735.735 0 0 1 .104.374zM8 0a1 1 0 0 1 1 1c0 .141-.033.273-.09.392-.63-.272-1.306-.392-1.91-.392s-1.279.12-1.91.392A.985.985 0 0 1 7 1a1 1 0 0 1 1-1zm5.68 10.934A5.58 5.58 0 0 1 14 10a.51.51 0 0 1-.083-.006h-11.834A.51.51 0 0 1 2 10a5.58 5.58 0 0 1 .32 0h.012l1.29.752v.004a5.58 5.58 0 0 0 2.888.814h4.98a5.58 5.58 0 0 0 2.888-.814l1.29-.752z" />
      </svg>
      {count > 0 && <span className="bell-span">{count}</span>}
      <div ref={BellBoxRef} className={showPopup ? "" : "closeDiv"}>
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: -20,
            width: "500px",
            padding: "10px",
            boxShadow: "0 0 10px rgba(64, 101, 101, 0.1)",
            backgroundColor: "white",
            borderRadius: "4px",
            zIndex: 1000,
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <button
              onClick={() => handleCategoryChange("critical")}
              style={{
                background:
                  activeCategory === "critical" ? "#007bff" : "#f0f0f0",
                color: activeCategory === "critical" ? "#fff" : "#000",
                border: "none",
                padding: "5px 15px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Critical
            </button>
            <button
              onClick={() => handleCategoryChange("all")}
              style={{
                background: activeCategory === "all" ? "#007bff" : "#f0f0f0",
                color: activeCategory === "all" ? "#fff" : "#000",
                border: "none",
                padding: "5px 10px",
                marginRight: "4px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              All
            </button>
          </div>

          {filteredNotifications.length === 0 ? (
            <NoDataFound message1="No Notifications found" message2="" />
          ) : (
            <div>
              <Table className="table" borderless>
                <tbody className="table-body">
                  {filteredNotifications.slice(0, 5).map((data) => {
                    return (
                      <Fragment key={data._id}>
                        <tr>
                          <td style={{ borderBottom: "1px solid #ddd" }}>
                            {ConstructNotificationMessage(data)}
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
                  {loading && (
                    <tr>
                      <td className="text-center" colSpan={5}>
                        Loading...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}

          <div style={{ textAlign: "center" }}>
            <button
              onClick={viewedAll}
              style={{
                background: "#007bff",
                color: "#fff",
                border: "none",
                padding: "5px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              View More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationBell;
